import { render, staticRenderFns } from "./addDCForm.vue?vue&type=template&id=039f9026&scoped=true&"
import script from "./addDCForm.vue?vue&type=script&lang=js&"
export * from "./addDCForm.vue?vue&type=script&lang=js&"
import style0 from "./addDCForm.vue?vue&type=style&index=0&id=039f9026&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "039f9026",
  null
  
)

export default component.exports